import React, {useState} from 'react';
import { Row, Col } from '../../bootstrap/index.jsx';

const AdditionalFormFields = ({additional_fields, data_types, readOnly}) => {

  const [data, setData] = useState(additional_fields || [])
  const [types, setTypes] = useState(Object.values(data_types))

  let editMode = false;
  if (typeof additional_fields != 'undefined') {
    editMode = true;
  }

  function addDis(e) {
    e.preventDefault();
    setData(data.concat({id: 0, name:"", data_type: data_types[0]}))
  }

  function removeDis(e, id) {
    e.preventDefault();
    var newData = data
    newData.splice(id, 1)
    setData([...newData])
  }

  function updateName(name, id, parentIndex) {
    if (parentIndex != null) {
      var newData = data
      newData[parentIndex].tmps[id].name = name
      setData([...newData])
    } else {
      var newData = data
      newData[id].name = name
      setData([...newData])
    }
  }

  function updateType(type, id) {
      var newData = data
      newData[id].data_type = type
      setData([...newData])

  }

  return (
    <Row className="form-group">
      <Col className="indicator-additional-field-container">
        <label>
          {I18n.t('additional_fields')}
          <p>
            <small className="text-muted">{I18n.t('indicator_additional_fields_instruction')}</small>
          </p>
        </label>

        {editMode && !readOnly &&
          <div className='alert alert-warning'>
            {I18n.t('additional_fields_edit_warning')}
          </div>
        }

        {data != [] && data.map((v, i) => {
          return <Category 
            name={v.name}
            data_type={v.data_type}
            id={v.id}  
            index={i} 
            removeDis={removeDis}
            updateName={updateName}
            updateType={updateType}
            key={i}
            types={types}
            readOnly={readOnly}
          />
        })}

        {readOnly ? null : (
          <div className='form-group row' >
            <div className='col-xs-12' >
              <button className='pull-right btn btn-primary new-additional_field' onClick={addDis}>
                <span className='icon icon-add' ></span>
                { ' ' + I18n.t('add_additional_field')}
              </button>
            </div>
          </div>
        )}

        <input type="hidden" name="additional_field_state" value={JSON.stringify(data)} />
      </Col>
    </Row>
  );
}


const Category = ({name, id, index, removeDis, updateName, types, data_type, updateType, readOnly}) => {

  return (
    <div className='indicator-additional-field-row'>

      <div className='row' >

        <div className='col-xs-7' >
          <input name={"additional_fields[" + index + "][name]"} value={name} onChange={(e) => updateName(e.target.value, index, null)} className='col-xs-1 form-control' placeholder={I18n.t('name')} readOnly={readOnly}></input>
        </div>

        <div className='col-xs-4' >
          <select id='' name={"additional_fields[" + index + "][data_type]"} className='form-control' onChange={(e) => updateType(e.target.value, index)} value={data_type} disabled={readOnly}>
            {types.map(v => 
              <option key={v} value={v}>{I18n.t(v)}</option>
              ) }
          </select>
       </div>

        <div className='col-xs-1' >
          <input name={"additional_fields[" + index + "][id]"} value={id} type="hidden"/>
        </div> 

        <div className='col-xs-1' >
          {readOnly ? null : (
            <button className="pull-right btn btn-danger remove-additional_field small-remove-button" onClick={ (e) => removeDis(e, index) }>
              <span className='icon icon-trash' ></span>
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

export default AdditionalFormFields;